// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;0,700;1,300&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
    font-family: 'Poppins', sans-serif;
    
}
 .main-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 20px;
}
  
 .text-content {
    flex: 1 1;
    padding: 20px;
  }
  .text-content1 {
    flex: 1 1;
    padding: 20px;
    text-align: left;

  }
  .image-content {
    flex: 1 1;
    text-align: center; /* Center the image horizontally */
  }
  
  /* Style your text and image as needed */
  h1 {
    font-size: 24px;
    margin-bottom: 10px;
  }
  
  p {
    font-size: 16px;
    line-height: 1.5;
  }
  
  img {
    max-width: 70%; /* Ensure the image doesn't exceed its container width */
    max-height: 100%;
    border-radius: 6px;
  }
  
  .discover-button {
    background-color: skyblue; /* Button background color */
    color: #222; /* Button text color */
    font-size: 18px;
    font-weight: 600;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 20px; /* Adjust the margin as needed */
  }
  
  .discover-button:hover {
    background-color:  #6fa6e0;; /* Button background color on hover */
  }
  .sky-blue-background {
    background-color: rgb(227, 241, 246); 
    height: 500px;
  }
  
  
.bullet-points {
    list-style-type: none; 
    padding: 0;
  }
  
  .bullet-points li::before {
    content: '✔'; 
    color: #043366; 
    margin-right: 10px; 
  }
  .footer {
    padding: 20px;
    text-align: center;
    font-size: 14px;
  }
  
  @media (max-width: 768px) {
    .footer {
      font-size: 12px;
      padding: 10px;
    }
  }
  /* Add these CSS rules to your home.css file */

/* Style for the image row */
.image-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0; /* Adjust the margin as needed */
}

/* Style for each image and text container */
.image-content {
  text-align: center;
}

.image-content img {
  max-width: 100%;
  height: 350px;
  width: 350px;
  border: 2px solid #ddd;
  border-radius: 5px;
}

.image-content p {
  font-size: 14px;
  color: #555;
}

/* Media query for responsiveness (adjust as needed) */
@media (max-width: 768px) {
  .image-row {
    flex-direction: column;
  }

  .image-content {
    text-align: center;
    margin-bottom: 20px; /* Adjust the margin as needed */
  }

  .image-content img {
    max-width: 100%;
  }
}
/* Add this to your existing CSS or create a new CSS file */
.pricing-section {
 
  padding: 40px 0;
  text-align: center;
}

.pricing-section h1 {
  font-size: 24px;
  margin-bottom: 20px;
}

.price-toggler {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.month,
.year {
  padding: 10px 20px;
  cursor: pointer;
  border: 1px solid #ccc;
  background-color: #fff;
  margin: 0 5px;
}

.active {
  background-color: skyblue;
  color: #222;
  font-weight: 600;
}

.pricing-cards {
  display: flex;
  justify-content: center;
  align-items: center;
}

.pricing-card {
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 20px;
  margin: 0 10px;
  border-radius: 5px;
  flex: 1 1;
}

.hidden {
  display: none;
}

.pricing-card h2 {
  font-size: 20px;
  margin-bottom: 10px;
}


.price {
  font-size: 24px;
  font-weight: bold;
  margin: 10px 0;
}

.pricing-cards a  {
  display: inline-block;
  background-color: skyblue;
  color: #222;
  padding: 10px 20px;
  text-decoration: none;
  border-radius: 5px;
  font-weight: bold;
  transition: background-color 0.3s;
}

.pricing-cards a:hover {
  background-color: #6fa6e0;
}
.section {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px;
  padding: 5px;
  border-radius: 5px;
}

.section img {
  max-width: 100px;
  margin-right: 20px;
}

.section p {
  font-size: 16px;
}

.section a {
  text-decoration: none;
  color: blue;
}
@media (max-width: 768px) {
  .pricing-cards {
    flex-direction: column; /* Stack pricing cards on top of each other */
    align-items: center;
  }

  .pricing-card {
    max-width: 100%; /* Allow pricing cards to take up full width on smaller screens */
  }
}

.marketserve-section {
  padding: 20px;
  text-align: center;
}

.marketserve-section h1 {
  font-size: 24px;
  margin-bottom: 20px;
}

.marketserve-section ul {
  list-style: none;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.marketserve-section li {
  flex: 1 1;
  margin: 10px;
  padding: 20px;
  background-color: rgb(188, 219, 231);
  border: 1px solid #ddd;
  border-radius: 5px;
}

.marketserve-section h2 {
  font-size: 18px;
  margin-bottom: 10px;
}

.marketserve-section p {
  font-size: 14px;
}


.custom-marketserve-section {

  color: #222;
  padding: 20px;
  margin: 20px 0;
  text-align: center;
}
.marketserve-box h1{
  text-align: center;
}
.marketserve-box {

  padding: 30px;
  margin: 100px ;
  text-align: left;
  border: 1px solid #ccc; /* Add a border to create a box effect */
  border-radius: 10px; /* Add rounded corners */
}
`, "",{"version":3,"sources":["webpack://./src/home.css"],"names":[],"mappings":"AACA;IACI,kCAAkC;;AAEtC;CACC;IACG,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;CAEC;IACG,SAAO;IACP,aAAa;EACf;EACA;IACE,SAAO;IACP,aAAa;IACb,gBAAgB;;EAElB;EACA;IACE,SAAO;IACP,kBAAkB,EAAE,kCAAkC;EACxD;;EAEA,wCAAwC;EACxC;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc,EAAE,wDAAwD;IACxE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB,EAAE,4BAA4B;IACvD,WAAW,EAAE,sBAAsB;IACnC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB,EAAE,gCAAgC;EACpD;;EAEA;IACE,0BAA0B,GAAG,qCAAqC;EACpE;EACA;IACE,oCAAoC;IACpC,aAAa;EACf;;;AAGF;IACI,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE;MACE,eAAe;MACf,aAAa;IACf;EACF;EACA,8CAA8C;;AAEhD,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc,EAAE,gCAAgC;AAClD;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,sDAAsD;AACtD;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB,EAAE,gCAAgC;EACvD;;EAEA;IACE,eAAe;EACjB;AACF;AACA,2DAA2D;AAC3D;;EAEE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;;AAGA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE;IACE,sBAAsB,EAAE,6CAA6C;IACrE,mBAAmB;EACrB;;EAEA;IACE,eAAe,EAAE,iEAAiE;EACpF;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;;AAGA;;EAEE,WAAW;EACX,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,sBAAsB,EAAE,wCAAwC;EAChE,mBAAmB,EAAE,wBAAwB;AAC/C","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;0,700;1,300&display=swap');\r\n*{\r\n    font-family: 'Poppins', sans-serif;\r\n    \r\n}\r\n .main-content {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin: 20px;\r\n}\r\n  \r\n .text-content {\r\n    flex: 1;\r\n    padding: 20px;\r\n  }\r\n  .text-content1 {\r\n    flex: 1;\r\n    padding: 20px;\r\n    text-align: left;\r\n\r\n  }\r\n  .image-content {\r\n    flex: 1;\r\n    text-align: center; /* Center the image horizontally */\r\n  }\r\n  \r\n  /* Style your text and image as needed */\r\n  h1 {\r\n    font-size: 24px;\r\n    margin-bottom: 10px;\r\n  }\r\n  \r\n  p {\r\n    font-size: 16px;\r\n    line-height: 1.5;\r\n  }\r\n  \r\n  img {\r\n    max-width: 70%; /* Ensure the image doesn't exceed its container width */\r\n    max-height: 100%;\r\n    border-radius: 6px;\r\n  }\r\n  \r\n  .discover-button {\r\n    background-color: skyblue; /* Button background color */\r\n    color: #222; /* Button text color */\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    padding: 10px 20px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    margin-top: 20px; /* Adjust the margin as needed */\r\n  }\r\n  \r\n  .discover-button:hover {\r\n    background-color:  #6fa6e0;; /* Button background color on hover */\r\n  }\r\n  .sky-blue-background {\r\n    background-color: rgb(227, 241, 246); \r\n    height: 500px;\r\n  }\r\n  \r\n  \r\n.bullet-points {\r\n    list-style-type: none; \r\n    padding: 0;\r\n  }\r\n  \r\n  .bullet-points li::before {\r\n    content: '✔'; \r\n    color: #043366; \r\n    margin-right: 10px; \r\n  }\r\n  .footer {\r\n    padding: 20px;\r\n    text-align: center;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  @media (max-width: 768px) {\r\n    .footer {\r\n      font-size: 12px;\r\n      padding: 10px;\r\n    }\r\n  }\r\n  /* Add these CSS rules to your home.css file */\r\n\r\n/* Style for the image row */\r\n.image-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin: 20px 0; /* Adjust the margin as needed */\r\n}\r\n\r\n/* Style for each image and text container */\r\n.image-content {\r\n  text-align: center;\r\n}\r\n\r\n.image-content img {\r\n  max-width: 100%;\r\n  height: 350px;\r\n  width: 350px;\r\n  border: 2px solid #ddd;\r\n  border-radius: 5px;\r\n}\r\n\r\n.image-content p {\r\n  font-size: 14px;\r\n  color: #555;\r\n}\r\n\r\n/* Media query for responsiveness (adjust as needed) */\r\n@media (max-width: 768px) {\r\n  .image-row {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .image-content {\r\n    text-align: center;\r\n    margin-bottom: 20px; /* Adjust the margin as needed */\r\n  }\r\n\r\n  .image-content img {\r\n    max-width: 100%;\r\n  }\r\n}\r\n/* Add this to your existing CSS or create a new CSS file */\r\n.pricing-section {\r\n \r\n  padding: 40px 0;\r\n  text-align: center;\r\n}\r\n\r\n.pricing-section h1 {\r\n  font-size: 24px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.price-toggler {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.month,\r\n.year {\r\n  padding: 10px 20px;\r\n  cursor: pointer;\r\n  border: 1px solid #ccc;\r\n  background-color: #fff;\r\n  margin: 0 5px;\r\n}\r\n\r\n.active {\r\n  background-color: skyblue;\r\n  color: #222;\r\n  font-weight: 600;\r\n}\r\n\r\n.pricing-cards {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.pricing-card {\r\n  background-color: #fff;\r\n  border: 1px solid #ccc;\r\n  padding: 20px;\r\n  margin: 0 10px;\r\n  border-radius: 5px;\r\n  flex: 1;\r\n}\r\n\r\n.hidden {\r\n  display: none;\r\n}\r\n\r\n.pricing-card h2 {\r\n  font-size: 20px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n\r\n.price {\r\n  font-size: 24px;\r\n  font-weight: bold;\r\n  margin: 10px 0;\r\n}\r\n\r\n.pricing-cards a  {\r\n  display: inline-block;\r\n  background-color: skyblue;\r\n  color: #222;\r\n  padding: 10px 20px;\r\n  text-decoration: none;\r\n  border-radius: 5px;\r\n  font-weight: bold;\r\n  transition: background-color 0.3s;\r\n}\r\n\r\n.pricing-cards a:hover {\r\n  background-color: #6fa6e0;\r\n}\r\n.section {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 20px;\r\n  padding: 5px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.section img {\r\n  max-width: 100px;\r\n  margin-right: 20px;\r\n}\r\n\r\n.section p {\r\n  font-size: 16px;\r\n}\r\n\r\n.section a {\r\n  text-decoration: none;\r\n  color: blue;\r\n}\r\n@media (max-width: 768px) {\r\n  .pricing-cards {\r\n    flex-direction: column; /* Stack pricing cards on top of each other */\r\n    align-items: center;\r\n  }\r\n\r\n  .pricing-card {\r\n    max-width: 100%; /* Allow pricing cards to take up full width on smaller screens */\r\n  }\r\n}\r\n\r\n.marketserve-section {\r\n  padding: 20px;\r\n  text-align: center;\r\n}\r\n\r\n.marketserve-section h1 {\r\n  font-size: 24px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.marketserve-section ul {\r\n  list-style: none;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.marketserve-section li {\r\n  flex: 1;\r\n  margin: 10px;\r\n  padding: 20px;\r\n  background-color: rgb(188, 219, 231);\r\n  border: 1px solid #ddd;\r\n  border-radius: 5px;\r\n}\r\n\r\n.marketserve-section h2 {\r\n  font-size: 18px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.marketserve-section p {\r\n  font-size: 14px;\r\n}\r\n\r\n\r\n.custom-marketserve-section {\r\n\r\n  color: #222;\r\n  padding: 20px;\r\n  margin: 20px 0;\r\n  text-align: center;\r\n}\r\n.marketserve-box h1{\r\n  text-align: center;\r\n}\r\n.marketserve-box {\r\n\r\n  padding: 30px;\r\n  margin: 100px ;\r\n  text-align: left;\r\n  border: 1px solid #ccc; /* Add a border to create a box effect */\r\n  border-radius: 10px; /* Add rounded corners */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
